import { fetchAction, fetchActionPost, fetchPostApi } from "../../../helpers/fetch";

export const fetchSendMessage = (body) => fetchPostApi('/api/chats/send', body)

export const addNewMessageToChat = (body) => {
    return {
        type: 'ADD_NEW_MESSAGE_TO_CHAT',
        payload: body
    }
}

export const getChats = () => fetchAction('/api/chats/user', [
    'GET_CHATS_REQUEST',
    'GET_CHATS_SUCCESS',
    'GET_CHATS_FAILURE'
])

export const setCurrentChat = (chat) => ({
    type: 'SET_CURRENT_CHAT',
    payload: chat
})

export const sendMessage = (body) => fetchActionPost('/api/chats/send', body, [
    'SEND_MESSAGE_REQUEST',
    'SEND_MESSAGE_SUCCESS',
    'SEND_MESSAGE_FAILURE'
])

export const setChatRead = (chat_id) => fetchActionPost(`/api/chats/read/${chat_id}`, {}, [
    'SET_CHAT_READ_REQUEST',
    'SET_CHAT_READ_SUCCESS',
    'SET_CHAT_READ_FAILURE'
])

export const createChat = (body) => fetchActionPost('/api/chats/create', body, [
    'CREATE_CHAT_REQUEST',
    'CREATE_CHAT_SUCCESS',
    'CREATE_CHAT_FAILURE'
])

export const getChatsUnreadCount = () => fetchAction('/api/chats/unread-count', [
    'GET_CHATS_UNREAD_COUNT_REQUEST',
    'GET_CHATS_UNREAD_COUNT_SUCCESS',
    'GET_CHATS_UNREAD_COUNT_FAILURE'
])

// New actions for real-time message updates
export const receiveMessage = (message) => ({
    type: 'RECEIVE_MESSAGE',
    payload: message
})

export const updateChatWithNewMessage = (chatId, message) => ({
    type: 'UPDATE_CHAT_WITH_NEW_MESSAGE',
    payload: { chatId, message }
})

export const refreshChatMessages = (chatId) => async (dispatch) => {
    dispatch({ type: 'REFRESH_CHAT_MESSAGES_REQUEST', payload: { chatId } });

    try {
        // Use the existing /api/chats/user endpoint to get all chats
        const result = await dispatch(fetchAction('/api/chats/user', [
            'TEMP_REFRESH_CHAT_MESSAGES_REQUEST',
            'TEMP_REFRESH_CHAT_MESSAGES_SUCCESS',
            'TEMP_REFRESH_CHAT_MESSAGES_FAILURE'
        ]));

        if (result.success) {
            const allChats = result.response?.data || [];

            // Find the specific chat we're polling for
            const targetChat = allChats.find(chat => chat.id === chatId);

            if (targetChat) {
                // Dispatch with both chatId and messages from the specific chat
                dispatch({
                    type: 'REFRESH_CHAT_MESSAGES_SUCCESS',
                    payload: {
                        chatId,
                        messages: targetChat.messages || []
                    }
                });

                // Also update the full chats list if we got it
                dispatch({
                    type: 'GET_CHATS_SUCCESS',
                    payload: allChats
                });

                return { success: true, response: { data: targetChat.messages } };
            } else {
                throw new Error(`Chat with ID ${chatId} not found`);
            }
        } else {
            throw new Error(result.response?.message || 'Failed to refresh messages');
        }
    } catch (error) {
        dispatch({ type: 'REFRESH_CHAT_MESSAGES_FAILURE', payload: { chatId, error } });
        throw error;
    }
}